// src/components/ui/tooltip.jsx
"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils";

/**
 * <TooltipProvider> wraps all tooltips to provide context
 * <Tooltip>            := the root wrapper for each tooltip instance
 * <TooltipTrigger>     := the element that you hover/click
 * <TooltipContent>     := the pop-up itself
 */
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = React.forwardRef(
  (
    { className, sideOffset = 4, side = "top", align = "center", ...props },
    ref
  ) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 max-w-xs rounded-md p-2 shadow-md animate-in fade-in-80",
          // Light mode: white bg, dark text; Dark mode: dark bg, light text
          "bg-gray-200 text-gray-900 dark:bg-gray-900 dark:text-white",
          // Increase font size
          "text-sm",
          // Thicker border with theme-aware color
          "border-2 border-gray-300 dark:border-gray-700",
          className
        )}
        {...props}
      >
        {props.children}
        {/* Arrow matches background color */}
        <TooltipPrimitive.Arrow className="fill-white dark:fill-gray-900" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
);
TooltipContent.displayName = "TooltipContent";
